/**
 @ngdoc service
 @name mapExpenseclaimTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapExpenseclaimTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            if(rawTileData.itemCorporateURI){
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkBusinessModelField('jobId', 'itemPrincipleURI', 'itemCorporateURI'));
            }
            else {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('jobId','itemPrincipleURI'));

            }

            tileFactory.addFieldToColumn1(tileFactory.field.newValueWithCurrencyField('totalClaim'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('jobTitle'));
           if(tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationFieldWithLink('procurerOrgUnitName','procurerOrgName','businessURI'))
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('candidateName','candidateURI'));
               tileFactory.addFieldToColumn2(tileFactory.field.newLinkField('hiringManager','hiringManagerURI'));
           }else {
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('procurerOrgUnitName', 'procurerOrgName'));
            }
            tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('supplierOrgUnitName', 'supplierOrgName'));

            tileFactory.addFieldToColumn3(tileFactory.field.newField('expenseTypes'));
            tileFactory.addFieldToColumn3(tileFactory.field.newDateRangeField('startDate', 'endDate'));


            tileFactory.addFieldToColumn4(tileFactory.field.newFieldBooleanYesOrNo('alteredByUser'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('comments'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('mgrComments'));

            // Adding status

            // expenseClaimStatus
            // 532: "Not Submitted"
            // 533: "Awaiting Authorisation"
            // 534: "Awaiting Resubmission"
            // 535: "Awaiting Repost (financials)"
            // 536: "Rejected"
            // 537: "Authorised"
            // 538: "Passed for Payment"
            // 4826: "Cancelled"
            // 4827: "Awaiting Repost (allocation)"
            // 4953: "In Review"
            // 4954: "Processing"
            // 5161: "Awaiting Overtime Authorisation"
            // 5276: "Reversed"
            // 5397: "Awaiting Repost Authorisation (allocation)"
            // 5398: "Awaiting Repost Authorisation (financials)"

            if(rawTileData.additionalStatus){
                tileFactory.addStatus(tileFactory.status.newCombinedStatus('expenseClaimStatus', 'additionalStatus',
                    // Positives
                    [],
                    // Negatives
                    [],
                    // Warnings
                    [
                        [tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_AUTHORISATION, rawTileData.additionalStatus]
                    ]
                ));
            }else{
                tileFactory.addStatus(tileFactory.status.newStatus('expenseClaimStatus',
                    // Positives
                    [
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AUTHORISED
                    ],
                    // Negatives
                    [
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_REJECTED
                    ],
                    // Warnings
                    [
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_AUTHORISATION,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_FINANCIALS,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_ALLOCATION,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_AUTHORISATION_ALLOCATION,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_AUTHORISATION_FINANCIALS,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_IN_REVIEW
                    ]
                ));
            }

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapExpenseclaimTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapExpenseclaimTileService', mapExpenseclaimTileService);

}());